<template>
	<div>
    <label-tag :tagArray="[$t('vocabulary_mission')]"/>
		<div class="m-5" style="overflow: auto;" >
      <vocabulary-form/>
		</div>
	</div>
</template>

<script>
import vocabularyForm from './VocabularyForm'
import labelTag from './Label'
export default {

  name: 'Vocabulary',

  data () {
    return {
    }
  },
  components: {
    labelTag,
    vocabularyForm
  },
  methods: {
  }
}
</script>

<style lang="scss" scoped>
// @import "../../../assets/style/color.scss";
  .tag {
    text-align: left;
    border-bottom: #70f3d0 solid 2px;
    .tag-boxes {
      margin-left: 50px;
    }
  }
  .tag-body {
		cursor: pointer;
    display: inline-block;
    padding: 2px 10px;
    border-radius: 10px 10px 0 0;
    border-top: 2px #70f3d0 solid;
    border-right: 2px #70f3d0 solid;
    border-left: 2px #70f3d0 solid;
    color: #41cfa9;
	}
	.table {
    white-space:nowrap;
		text-align: left;
    font-size: 1.25rem;
    select, input {
      height: 2rem;
      min-width: 80px;
    }
	}

</style>


// WEBPACK FOOTER //
// VocabularyMission.vue?3e0471e4